import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const OrthopedicsIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="4.5" cy="4.5" r="2" stroke="#CCCCCC" strokeWidth="1.5" fill="none" />
      <circle cx="11.5" cy="11.5" r="2" stroke="#CCCCCC" strokeWidth="1.5" fill="none" />
      <path
        d="M6 6L10 10"
        stroke="#CCCCCC"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
